import style from "./Button.module.scss";

function BlueButton({ id = "", isCapitalize = false, isGradient = false, type = "button", btnClickHandler = () => {}, children, disabled = false, isActive = false, from = "" }) {
	return (
		<button
			id={id}
			disabled={disabled}
			className={`${isActive ? style.active : ""} ${style.btn} ${style["btn-blue"]} ${isGradient ? style.gradient : ""} ${isCapitalize ? style.capitalize : ""}`}
			type={type}
			onClick={btnClickHandler}
		>
			{children}
		</button>
	);
}

export default BlueButton;
